import { Inject, Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie";

import { IConfig, LANGUAGE_CONFIG } from "./language.tokens";

@Injectable()
export class LanguageService {
  private KEY = "preferredlang";

  constructor(
    private readonly _cookieService: CookieService,
    @Inject(LANGUAGE_CONFIG) private readonly _config: IConfig
  ) {}

  set(language: "en" | "fr") {
    return this._cookieService.put(this.KEY, language, {
      domain: this._config.domain
    });
  }

  get(): "en" | "fr" {
    const language =
      this._cookieService.get(this.KEY) || this.preferredBrowserLanguage();

    switch (language) {
      case "fr":
        return "fr";
      default:
        return "en";
    }
  }

  private preferredBrowserLanguage() {
    if (navigator.language.startsWith("fr")) {
      return "fr";
    }

    return "en";
  }
}
